export const CustomFieldType = {
  Text: 'text',
  Url: 'url',
  Date: 'date',
  DateTime: 'datetime',
  Number: 'number',
} as const

export type ICustomFieldType = (typeof CustomFieldType)[keyof typeof CustomFieldType]

type IFieldBase = {
  key: string
  name: string
  type: ICustomFieldType
}

type IDefaultFieldPart = {
  visible: boolean
  editable: boolean
  category_new: string
  is_values_required?: boolean
}

type ICustomFieldPart = {
  visible: 1 | 0
  key: `custom.${string}`
  organization_id: number
  is_used: boolean
  id: number
}

export type IDefaultField = IFieldBase & IDefaultFieldPart
export type ICustomField = IFieldBase & ICustomFieldPart
export type IField = IDefaultField | ICustomField

export type IParamsCustomField = {
  name: string
  type: ICustomFieldType
  visible: boolean
}

export type IParamsPaginatedCustomFields = {
  search?: string
  page?: number
  length?: number
}
export type IParamsAllCustomFields = { types?: ICustomFieldType[]; system?: string[]; all: true }
export type IParamsCustomFields = IParamsPaginatedCustomFields | IParamsAllCustomFields

type IResponseAllCustomFields = IField[]
type IResponsePaginatedCustomFields = {
  current_page: number
  last_page: number
  per_page: number
  total: number
  from: number
  to: number
  data: IField[]
}
export type IResponseCustomFields<T extends IParamsCustomFields = IParamsCustomFields> =
  T extends IParamsPaginatedCustomFields
    ? IResponsePaginatedCustomFields
    : T extends IParamsAllCustomFields
    ? IResponseAllCustomFields
    : never

export type IResponseCustomField = {
  data: ICustomField
  status: string
}

export type IResponseDeleteCustomField = {
  status: string
}

export type IResponseCustomFieldTypes = {
  data: {
    types: Record<string, string>
  }
}

export type IResponseCustomFieldError = {
  name?: string[]
  type?: string[]
}
